import { Variants } from 'framer-motion'

// Easing curves
export const easing = {
  easeOut: [0, 0, 0.2, 1],
  entrance: [0.6, -0.05, 0.01, 0.99],
} as const

// Stagger animations for lists
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.15,
      duration: 0.3,
      ease: easing.entrance
    }
  }
}

export const staggerItem: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
    transition: { duration: 0.3, ease: easing.entrance }
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: easing.entrance,
      type: 'tween'
    }
  }
}

// Navigation animations
export const navSlideDown: Variants = {
  hidden: {
    opacity: 0,
    y: -10,
    transition: { duration: 0.2, ease: easing.easeOut }
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: easing.easeOut }
  }
}

// Button hover animations
export const buttonHover = {
  scale: 1.02,
  transition: { duration: 0.2, ease: easing.easeOut }
}

export const buttonTap = {
  scale: 0.98,
  transition: { duration: 0.1, ease: easing.easeOut }
}

// Reduced motion variants (for accessibility)
export const reduceMotion = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } }
}
